export const whitepapers = 'whitepapers';
export const webinars = 'webinars';
export const videos = 'videos';
export const ebooks = 'ebooks';

export default {
  whitepapers,
  webinars,
  videos,
  ebooks
};



// WEBPACK FOOTER //
// ./src/pages/resources/labels.js